import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Verrouillé / sécurisé — cadenas duotone */
export const LockIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Corps du cadenas menthe */}
      <rect x="4" y="11" width="16" height="10" rx="2" fill="var(--equiply-icon-bg)" />
      {/* Contour corps */}
      <rect x="4" y="11" width="16" height="10" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Anse */}
      <path
        d="M8 11V8a4 4 0 0 1 8 0v3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Trou serrure */}
      <circle cx="12" cy="15.5" r="1.25" fill="var(--equiply-icon-fg)" />
      <path d="M12 16.5v1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
LockIcon.displayName = "LockIcon";
